<template>
  <div class="about margin-between-section">
    <div class="row not-margin">
      <div class="col-md-12 col-lg-12">
        <div class="info">
          <h1>{{ $t('home.about_title') }}</h1>
          <p>{{ $t('home.about_txt') }}</p>
          <p>{{ $t('home.about_txt2') }}</p>
          <p>{{ $t('home.about_txt3') }}</p>
          <p>{{ $t('home.about_txt4') }}</p>
        </div>
      </div>

      <div class="col-md-12 not-padding container-info">
        <iframe v-if="$t('flag.flag') == 'es'"  src="https://iframe.videodelivery.net/e18474431b548f82e3ff7cb78ecc7dda?autoplay=true" style="border: none;" height="720" width="1280" allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;" allowfullscreen="true"></iframe>
        <iframe v-if="$t('flag.flag') == 'en'" src="https://iframe.videodelivery.net/345959f3e37b710325493c7a48881649?autoplay=true" style="border: none;" height="720" width="1280" allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;" allowfullscreen="true"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'about',
  data () {
    return {
      idiom: ''
    }
  },
  beforeMount() {
    this.idiom = this.$t('flag.flag')
  },
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

iframe{
  margin: 10px auto;
  max-width: 100%;
}

.info{
  text-align: left;
}

.info h1{
  font-size: 25px;
  font-family: 'plain regular', arial;
  margin-bottom: 45px;
}

.info p{
  padding-top: 1%;
  font-size: 15px;
  line-height: 30px;
}

.container-info{
  display: flex;
  align-items: center;
}

.not-margin{
  margin: 0;
}
.not-padding{
  padding: 0;
}
.img-about{
  width: 90%;
  position: absolute;
  right: 0;
}


/* Mobile first queries */

/* Larger than Desktop HD */
@media (max-width: 1200px) {}

/* Larger than desktop */
@media (max-width: 992px) {
  .img-about{
    margin-top: 30px;
    width: 100%;
    position: relative;
  }
  .info p{
    font-size: 16px;
  }
}

/* Larger than tablet */
@media (max-width: 768px) {

  .info p{
    font-size: 15px;
    line-height: 22px;
  }

}

/* Larger than phablet */
@media (max-width: 550px) {
  .info p{
    font-size: 14px;
  }
  .img-about{
    display: none;
  }
}

/* Larger than mobile */
@media (max-width: 400px) {}

</style>
